export default {
  path: '',
  component: {
    template: '<router-view :key="$route.fullPath" />'
  },
  meta: {
    title: '设置',
    navbar: 'el-icon-setting'
  },
  children: [
    {
      path: '/site_settings',
      name: 'site_settings.index',
      component: require('./site-settings/show').default,
      meta: {
        title: '商城设置',
        navbar: 'el-icon-discount',
        permission: 'site_settings.read'
      }
    },
    {
      path: '/site_settings/edit',
      name: 'site_settings.edit',
      component: require('./site-settings/edit').default,
      meta: {
        title: '修改商城配置',
        permission: 'site_settings.update'
      }
    },
    {
      path: '/dev_settings',
      name: 'dev_settings.index',
      component: require('./dev-settings/edit').default,
      meta: {
        title: '开发配置',
        navbar: 'el-icon-no-smoking',
        permission: 'site_settings.read'
      }
    },
    ...require('./pages/route').default,
  ]
}
